import React, { Component }  from 'react'
import { Redirect } from 'react-router-dom'

import TextField from 'react-md/lib/TextFields'
import Toolbar from 'react-md/lib/Toolbars'
import FontIcon from 'react-md/lib/FontIcons'

import './TokenHandler.css'
//import SensotixLogoWhite from 'img/sensotix-logo-white.svg'
//import Cleave from 'cleave.js'

import imgTokenHelp from 'img/token-help.png' // minify-service: https://www.giftofspeed.com/png-compressor/

class TokenHandler extends Component {
	state = {
		currentStep: 1,
		tokenMaxLength: 9,
		token: "",
		tag: () => this.state.token
	};

	componentDidMount() {
		//const error = _.get(this.props, 'history.location.state');

		this.textfieldToken.getField().focus();
		this.textfieldToken.getField().setSelectionRange(0, 0);
	}

	componentDidUpdate() {
		const { currentStep } = this.state;
		if (currentStep === 1) this.textfieldToken.getField().focus();
	}

	onButtonQRScanner = () => this.props.history.push('/home/qr');

	onChangeTextfieldToken = (value) => {
		/* restrict entry to 9 characters */
		value = value.replace(/[^a-zA-Z0-9]/g, "").substr(0, this.state.tokenMaxLength).toUpperCase();

		let dispValue = value;
		//if (value.length > 3) dispValue = value.substr(0, 3) + " " + value.substr(3);
		//if (value.length > 6) dispValue = dispValue.substr(0, 7) + " " + value.substr(6);

		const field = this.textfieldToken.getField();
		field.value = dispValue;

		if (value.length === this.state.tokenMaxLength) {
			this.setState({...this.state, currentStep: 2, token: value });
		} else {
			this.setState({...this.state, currentStep: 1, token: value });
		}
	};

	render() {
		const { currentStep } = this.state;

		const qrScanningSupported = !!navigator.mediaDevices;

		const prefix = window.location.hostname.startsWith("zeituhr1938") ? "180301/" : "";

		const redirectParams = {
			pathname: "/"+prefix+this.state.tag(),
			state: {
				handler: {
					origin: "/home/token",
					errorMessage: "Der Abrufcode ist ungültig. Bitte versuchen Sie es erneut."
				}
			}
		};

		const renderTitle = () => window.location.hostname.startsWith("zeituhr1938") ? "ZEITUHR 1938" : `Sensotix Smart Stickers`;
		//const renderLogo = () => <img className="title-logo" src={SensotixLogoWhite} alt="Sensotix" height="35px"/>

		const renderIcon = () => <FontIcon style={{cursor: "pointer"}} onClick={this.onButtonQRScanner}>photo_camera</FontIcon>;

		return (
			<div>
				{ currentStep === 2 && <Redirect to={redirectParams} /> }
				<Toolbar
					colored
					title={renderTitle()}
					//nav={renderLogo()}
				/>
				<div className="token-container">
					<div className="token-container-title">
						<span>Willkommen!</span>
						<br />
						{  qrScanningSupported && <div><span>Geben Sie hier den 9-stelligen Abrufcode Ihres Stickers ein oder wählen Sie die Foto-Option:</span></div> }
						{ !qrScanningSupported && <span>Geben Sie hier den 9-stelligen Abrufcode Ihres Stickers ein:</span> }
					</div>
					<div className="token-container-webcode">
						<TextField
							id="textfieldToken"
							className="md-cell md-cell--12"
							ref={(c) => this.textfieldToken = c}
							//label={`Abrufcode eingeben oder QR-Code scannen`}
							rightIcon={qrScanningSupported && renderIcon()}
							//helpText={`${tokenMaxLength}-stelliger Abrufcode`}
							//maxLength={tokenMaxLength}
							helpOnFocus
							onChange={this.onChangeTextfieldToken}
							type="text"
							autoFocus
						/>
					</div>
					<div className="token-container-help">
						{ currentStep === 1 && <div><img className="imgTokenHelp" src={imgTokenHelp} alt="Sticker" style={{textAlign: "center"}}/></div> }
					</div>
					<div className="token-container-footer">
						© 2018 Sensotix GmbH, Austria ・ <a href="https://www.sensotix.com" target="_blank" rel="noopener noreferrer">www.sensotix.com</a>
					</div>
				</div>
			</div>
		);
	}
}

export default TokenHandler


// WEBPACK FOOTER //
// ./src/components/home/tokenHandler/TokenHandler.jsx